import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { SIMPLE_FOOD_MOOD_FRAGMENT } from '../fragments'

const FOOD_MOODS_QUERY = gql`
  query foodMoods {
    foodMoods {
      results {
        ...SimpleFoodMoodFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${SIMPLE_FOOD_MOOD_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default FOOD_MOODS_QUERY
